import { deleteProperty } from "@/services/helpers";

export const pricingTierAdded = (state, payload) => {
  state.list = { ...state.list, [payload.id]: payload };
};

export const replacePricingTier = (state, payload) => {
  state.list[payload.id] = payload;
};

export const pricingTierRemoved = (state, payload) => {
  state.list = deleteProperty(state.list, payload.toString());
};

export const pricingTierRestored = (state, payload) => {
  const updatedPricingTier = { ...state.list[payload], deleted_at: false };
  state.list = { ...state.list, [payload]: updatedPricingTier };
};

export const initPricingTiers = (state, payload) => {
  state.list = payload;
  state.loaded = true;
};

export const reset = (state, payload) => {
  state.list = {};
  state.loaded = false;
};
